<td miqStopClick scope="col" *ngIf="selectable || showGoToRecordColumn || (sortable && sortMode === SortMode.Dragging)">
  <div
    class="complex-table-select-column fx--h fx--ali-center fx--juc-space-between"
    [ngClass]="{ 'complex-table-select-column__additonalWidth': selectable && showGoToRecordColumn }"
  >
    <!-- Checkbox to select the row -->
    <ng-container *ngIf="selectable && (hasEDPWriteAccess$ | async)">
      <miq-tableCheckbox
        [value]="row"
        [disabled]="row?.rowClass || row.editMode || disableSelection"
      ></miq-tableCheckbox>
    </ng-container>

    <!-- Link to redirect the user to the record in a different tab -->
    <ng-container *ngIf="showGoToRecordColumn">
      <miq-goes-to-record
        svgIconName="open_in_new"
        useIcon="true"
        [data]="row"
        [linkGenerator]="rowLinkGenerator"
        targetAnchor="_blank"
      ></miq-goes-to-record>
    </ng-container>

    <ng-container *ngIf="sortMode === SortMode.Dragging">
      <!-- Manual Sorting Icon -->
      <span
        *ngIf="sortable; else disableDragging"
        pReorderableRowHandle
        class="pi pi-arrows-alt"
        [matTooltip]="sortMessage"
        matTooltipPosition="below"
      ></span>

      <!-- Disabled Manual Sorting Icon -->
      <ng-template #disableDragging>
        <span class="pi pi-arrows-alt fx--dark-gray-text" [matTooltip]="sortMessage" matTooltipPosition="below"></span>
      </ng-template>
    </ng-container>
  </div>
</td>

<td *ngFor="let col of columns" [style.height]="col?.height || '60px'" #rowContainer>
  <ng-container *ngIf="col?.editable && row?.editMode && (row | canUpdateRow: col : _rowChanges); else presentational">
    <miq-editing-box-field
      class="associated-item"
      [id]="'e2e-complextable-editbox-' + col.columnId"
      [record]="row"
      [column]="col"
      (modified)="onChange($event)"
    ></miq-editing-box-field>
  </ng-container>
  <ng-template #presentational>
    <p class="data-row" [class.reversed]="col.showHandler && col.clickHandler.position === Position.AFTER">
      <!-- link generator -->
      <ng-container *ngIf="col.linkGenerator != null; else otherCustomConfigs">
        <miq-goes-to-record [data]="row" [linkGenerator]="col.linkGenerator">
          <ng-container *ngTemplateOutlet="defaultCellRenderer; context: { row: row, col: col }"></ng-container>
        </miq-goes-to-record>
      </ng-container>

      <ng-template #otherCustomConfigs>
        <!-- custom click handler -->
        <ng-container *ngIf="col.showHandler">
          <ng-container *ngTemplateOutlet="columnClickHandlerOption"></ng-container>
        </ng-container>

        <!-- CONTENT -->
        <ng-container *ngIf="!col?.disableDisplay">
          <ng-container *ngTemplateOutlet="defaultCellRenderer; context: { row: row, col: col }"></ng-container>
        </ng-container>
      </ng-template>
    </p>
  </ng-template>

  <ng-template #columnClickHandlerOption>
    <a miqStopClick (click)="colClickEvent(col, row, $event)" [matTooltip]="col?.clickHandler?.toolTip">
      <ng-container *ngIf="col.clickHandler.icon || col.clickHandler.svgIcon">
        {{ col.clickHandler.text ? col.clickHandler.text : '' }}
        <mat-icon *ngIf="col.clickHandler.svgIcon" [svgIcon]="col.clickHandler.svgIcon"></mat-icon>
        <mat-icon *ngIf="col.clickHandler.icon">{{ col.clickHandler.icon }}</mat-icon>
      </ng-container>

      <ng-container *ngIf="col.clickHandler.displayValue">
        <ng-container *ngTemplateOutlet="defaultCellRenderer; context: { row: row, col: col }"></ng-container>
      </ng-container>
    </a>
  </ng-template>
</td>
<td *ngIf="expandable" miqStopClick>
  <a (click)="toggle.emit(row)">{{
    row.expanded ? (expandedMessage | xTranslate) : (nonExpandedMessage | xTranslate)
  }}</a>
</td>

<ng-template #defaultCellRenderer let-col="col" let-row="row">
  {{ row | dataCellFormatter: col }}
  <ng-container *ngIf="col.unit">
    {{ row | dataCellFormatter: col.unit }}
  </ng-container>
</ng-template>
